import { MessageSquareIcon } from "lucide-react";
import { FC } from "react";

import { Dialog, DialogContent } from "@/components/ui/dialog";
import { FilesSelectTree } from "@/components/app/files-select-tree";
import { Item } from "@/types/fse";
import { Button } from "@/components/ui/button";
import { Link } from "react-router";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const ApplyPromptLibraryItemDialog: FC<Props> = ({ isOpen, setIsOpen }) => (
  <div className="flex flex-grow flex-col space-y-4 overflow-hidden">
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="flex h-[80vh] max-h-[600px] w-full max-w-[60vw] flex-grow flex-col">
        <FilesSelectTree
          showFiles={true}
          showFolders={true}
          onAction={_item => {
            // no-op
          }}
          actionButton={(item: Item) => (
            <Button variant="secondary" size="sm" className="flex w-full text-xs sm:w-auto" type="button">
              <Link to={`/chat/${item.id}`} className="flex">
                <MessageSquareIcon className="mr-1 h-4 w-4" />
                Q&A
              </Link>
            </Button>
          )}
        />
      </DialogContent>
    </Dialog>
  </div>
);
